import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(() => ({
  line: {
    display: "flex",
    // Classes bumping to increase specificity
    // for overriding global styles on the checkout page:
    // `svg:not(:root)`
    "&&": {
      // Due to peculiarities of browser rendering
      // the `line` element is slightly outside the parent SVG,
      // so we use `overflow: visible` to avoid clipping it off.
      overflow: "visible"
    }
  }
}));
